import React from 'react'
import {YMaps, Map, Placemark, ZoomControl} from "@pbe/react-yandex-maps";

import moscow from '../../../../images/job/moscow.png'
import volginsky from '../../../../images/job/volginsky.png'
import metro1 from '../../../../images/job/metro1.svg'
import metro2 from '../../../../images/job/metro2.svg'
import metro3 from '../../../../images/job/metro3.svg'
import icon1 from '../../../../images/job/icon1.svg'
import icon2 from '../../../../images/job/icon2.svg'
import icon3 from '../../../../images/job/icon3.svg'
import icon4 from '../../../../images/job/icon4.svg'


import styles from './styles.module.scss'
import vector_right from '../../../../images/basic/header/vector_right.svg'
import {Link} from 'react-router-dom'
import parse from 'html-react-parser'
import whywework from "../../../../images/job/whywework.png";


const WyWeWork = ({vacationInfo, info}) => {
  let vacationInfoReal =  vacationInfo ? vacationInfo : info
  let _advantages_city = vacationInfoReal ? vacationInfoReal?.city?.advantages_city : null
  const center = vacationInfoReal?.city?.coords.split(',');

  return (
    <div className={styles.wrapper}>
      <div className={styles.wrapper_up}>
        <p className={styles.title}>Локация</p>
        <div className={styles.wrapper_up_info}>
          {'' !== vacationInfoReal?.city?.coords ? (
            <><YMaps query={{lang: 'ru_RU'}}>
              <Map
                state={{
                  center,
                  zoom: 16,
                  controls: []
                }}
                className={styles.wrapper_up_info_ymaps}
                instanceRef={ref => { ref && ref.behaviors.disable('scrollZoom'); }}
              >
                <ZoomControl options={{position: {right: 20, left: 'auto', top: 50, bottom: 'auto'} }} />
                <Placemark
                  geometry={center}
                  options={{
                    iconLayout: "default#image",
                    iconImageSize: [56, 56],
                    iconImageHref: "/upload/map-pin.png"
                  }}
                />
              </Map>
            </YMaps></>) : ''}
          <div className={styles.wrapper_info_right}>
            <div className={styles.wrapper_right_info_block}>
              <p className={styles.wrapper_right_info_block_p1}>{vacationInfoReal?.city?.name_location}</p>
              <p className={styles.wrapper_right_info_block_p2}>{vacationInfoReal?.city?.address_location}</p>
            </div>
          </div>
        </div>
        <div className={styles.wrapper_down}>
          {_advantages_city !== null && _advantages_city!==undefined ?
          _advantages_city
            .filter((elem, i) => i < 8)
            .map((item, index) => (
              <>
            <div key={index} className={styles.wrapper_down_item}>
              <img src={_advantages_city[index].adventageSVG} alt='icon' draggable='false'/>
              <div>
                <p className={styles.wrapper_down_item_p1}>{parse(_advantages_city[index].adventageName)}</p>
                <p className={styles.wrapper_down_item_p2}>{parse(_advantages_city[index].adventageDesc)}</p>
              </div>
            </div>
            </>)
            ) : ""}
        </div>
        {'' !== vacationInfoReal?.city?.link ? (
            <>
        <div className={styles.wrapper_button}>
          <Link to={vacationInfoReal?.city?.link} className={styles.button}>
            Узнать больше о жизни в Вольгинском <span>&rarr;</span>
          </Link>
          <Link to={vacationInfoReal?.city?.link} className={styles.phone_button}>
            Больше о Вольгинском <span>&rarr;</span>
          </Link>
        </div></>) : ''}
      </div>
      <div className={styles.down}>
        <div className={styles.down_text}>
          <div className={styles.down_text_wrapper}>
            <p className={styles.down_text_wrapper_p1}>Узнать больше о компании</p>
            <p className={styles.down_text_wrapper_p2}>Наши проекты, продукты и планы</p>
            <a className={styles.down_text_wrapper_btn} href="https://youtu.be/vOfU7eA4UcA" target="_blank">
              Посмотреть ролик
              <img className={styles.vector_right} src={vector_right} alt='vector' draggable='false'/>
            </a>
          </div>
        </div>
        <div className={styles.down_img}>
          <img src={whywework} alt='whywework' draggable='false'/>
        </div>
      </div>
    </div>
  )
}

export default WyWeWork
